// extracted by mini-css-extract-plugin
module.exports = {"documentBox":"documentBox--2Y28b","canvasBox":"canvasBox--TDKA_"};